<ion-content class="table-content">
  <app-dashboard-header (onSelected)="toggleFilterBody($event)" [filterComps]="filterComps" [filterObject]="filterObject"
                        [headerSetting]="headerSetting" [searchField]="searchField"
                        [showFilterBody]="showFilterBody"></app-dashboard-header>
  <div class="table-container dt-buttons-parent-element">
    <table class="display" id="complimentData"></table>
  </div>
</ion-content>
